import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { Accordion } from '../components/ui/Accordion';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, CheckCircle2, Plus, Minus, Sparkles, Smile, Palette, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-4555" data-mp="1el6a0lppf49z">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-4556" data-mp="1siusxo07o1ce" />
    </svg>;
}
export function VeneersLondonRuPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const faqs = [{
    q: 'Сколько стоят виниры в Лондоне?',
    a: 'Цена зависит от материала (керамика или композит), количества зубов и сложности работы. После консультации мы предлагаем детальный план лечения и смету.'
  }, {
    q: 'Нужно ли обтачивать зубы под виниры?',
    a: 'В большинстве случаев требуется минимальная подготовка эмали (0.3-0.5 мм), но объем зависит от клинической ситуации. Мы всегда выбираем максимально щадящий подход (minimally invasive).'
  }, {
    q: 'Сколько служат виниры?',
    a: 'Керамические виниры могут служить 10-15 лет и более при правильном уходе. Срок службы зависит от материала, прикуса и гигиены. На консультации мы объясняем, как продлить долговечность.'
  }, {
    q: 'Можно ли сделать естественный результат?',
    a: 'Да, это наша специализация. Мы подбираем форму, текстуру и цвет индивидуально, чтобы улыбка выглядела гармонично и натурально, а не искусственно.'
  }, {
    q: 'Какая разница между фарфоровыми и композитными винирами?',
    a: 'Фарфоровые (керамические) виниры прочнее, долговечнее и устойчивее к окрашиванию. Композитные виниры (bonding) доступнее по цене и часто устанавливаются за один визит, но требуют более частой полировки.'
  }, {
    q: 'Сколько визитов нужно для виниров?',
    a: 'Обычно 2-3 визита для керамических виниров: консультация, подготовка/оттиски, установка. Композитные виниры часто можно сделать за один визит.'
  }, {
    q: 'Можно ли получить консультацию на русском?',
    a: 'Да, в Dentico Clinic возможно общение на русском языке во время консультации и лечения.'
  }, {
    q: 'Где находится Dentico Clinic?',
    a: 'Angel / Islington, 360–364 City Road, London EC1V 2PY. 5 минут пешком от станции Angel.'
  }];
  // Schemas
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  const procedureSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: 'Dental Veneers',
    description: 'Cosmetic dental procedure to improve the appearance of teeth using veneers.',
    procedureType: 'http://schema.org/NoninvasiveProcedure',
    provider: {
      '@type': 'Dentist',
      name: 'Dentico Clinic',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '360-364 City Road',
        addressLocality: 'London',
        postalCode: 'EC1V 2PY',
        addressCountry: 'GB'
      }
    }
  };
  return <Layout data-id="element-4557" data-mp="2l366cvhpjm42">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-4558" data-mp="2l6u09vr2eajb" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-4559" data-mp="2c4krbabg2p81" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(procedureSchema)
    }} data-id="element-4560" data-mp="27c1cyb4xnq26" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-[#F8F5F0] overflow-hidden" data-id="element-4561" data-mp="1xghgnnmgipcw">
        <div className="absolute inset-0 bg-[#EFE8DE] -skew-y-3 origin-top-left transform translate-y-20" data-id="element-4562" data-mp="1te2yl5qm3tmo" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-4563" data-mp="1oe8b7c61pm6d">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-4564" data-mp="3ve85xbcaxo0">
            <div className="space-y-6" data-id="element-4565" data-mp="8vacxyrv2t4m">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EFE8DE] text-[#2F4A3F] border border-[#D8C4A8] text-sm font-medium" data-id="element-4566" data-mp="8u7mfrygasp8">
                <span className="relative flex h-2 w-2" data-id="element-4567" data-mp="hvysixwwl1jm">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-forest-600 opacity-75" data-id="element-4568" data-mp="hvflic8sjxkd"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-forest-700" data-id="element-4569" data-mp="3lcxfbfrqb41s"></span>
                </span>
                Эстетическая стоматология
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2B2D2F] leading-tight tracking-tight" data-id="element-4570" data-mp="3q9xo3yfyqkwl">
                Виниры в Лондоне –{' '}
                <span className="text-forest-700" data-id="element-4571" data-mp="2xmblotih1mbb">Dentico Clinic</span>
                <br data-id="element-4572" data-mp="32m6bsuufa7vb" />
                <span className="text-2xl sm:text-3xl font-medium text-stone-500 mt-2 block" data-id="element-4573" data-mp="32ledvddcry1v">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-4574" data-mp="4t4j3knguv6h">
                Создайте идеальную улыбку с помощью керамических виниров или
                композитного бондинга. Естественный результат, минимальное
                вмешательство, консультация на русском.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-[#2F4A3F]" data-id="element-4575" data-mp="3mzakxtxfs3uq">
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4576" data-mp="3i0g1cprnab9k">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-4577" data-mp="3w0h46argzsro" />
                  Smile Makeover
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4578" data-mp="1b8ygcbsolant">
                  <MapPin className="w-4 h-4 text-[#2F4A3F]" data-id="element-4579" data-mp="16anaec5ibkav" />
                  Angel, EC1V
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-4580" data-mp="1eq2zzhdv0wvi">
                  <Languages className="w-4 h-4 text-[#2F4A3F]" data-id="element-4581" data-mp="1iqd5ksxqpl9u" />
                  Русский язык
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-4582" data-mp="19r9m3nunv3ut">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4583" data-mp="19tmb2kyu6ehd">
                  <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#2F4A3F] !text-white !border !border-[#2F4A3F] hover:!bg-[#3A5A4D]" data-id="element-4584" data-mp="22i9ppxp2y5ly">
                    <Calendar className="w-5 h-5" data-id="element-4585" data-mp="2gg84v5b8662i" />
                    Записаться на консультацию
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4586" data-mp="2l7zsp82zxxoy">
                  <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#EFE8DE] !text-[#2F4A3F] !border !border-[#D8C4A8] hover:!bg-[#2F4A3F] hover:!text-white" data-id="element-4587" data-mp="gd6vdvrknlo0">
                    <MessageCircle className="w-5 h-5" data-id="element-4588" data-mp="7b7dz2cnafkj" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-4589" data-mp="z5rlx6jsteon">
              <div className="absolute inset-0 bg-[#D8C4A8] rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-4590" data-mp="z2n9jlw6jcmw"></div>
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Виниры и эстетическая стоматология - Dentico Clinic" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-4591" data-mp="q3s1035nxqgf" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE VENEERS */}
      <section className="py-16 bg-white" data-id="element-4592" data-mp="1vc4ev05vsg8x">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4593" data-mp="1v8oylu0h115x">
          <div className="text-center mb-10" data-id="element-4594" data-mp="1zbv4h0jo8qbv">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4595" data-mp="243d3hj24wgu7">
              Что такое виниры?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-4596" data-mp="292zfjp687r1f">
              Виниры — это ультратонкие керамические накладки, которые
              фиксируются на переднюю поверхность зубов для улучшения их формы,
              цвета и положения. Это идеальное решение для коррекции сколов,
              промежутков между зубами (диастем), изменения цвета эмали, который
              не поддается отбеливанию, или выравнивания незначительных
              неровностей.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-4" data-id="element-4597" data-mp="sny5cby6vixi">
              Современные виниры выглядят абсолютно естественно благодаря
              способности пропускать свет так же, как натуральная эмаль. В
              Dentico Clinic мы используем цифровые технологии для моделирования
              вашей будущей улыбки еще до начала лечения.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PROCESS */}
      <section className="py-16 bg-gray-50" data-id="element-4598" data-mp="1nvhe4fh1zhrb">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4599" data-mp="1str5sg3kk086">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-4600" data-mp="1stitapbcywxi">
            Путь к новой улыбке
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-4601" data-mp="1wt031uxtig8h">
            {[{
            step: '01',
            title: 'Консультация',
            desc: 'Обсуждение пожеланий, фотопротокол и цифровое моделирование улыбки.'
          }, {
            step: '02',
            title: 'Планирование',
            desc: 'Примерка макета (mock-up), чтобы вы увидели результат до начала работ.'
          }, {
            step: '03',
            title: 'Подготовка',
            desc: 'Минимальная обработка зубов и снятие точных оттисков или сканирование.'
          }, {
            step: '04',
            title: 'Фиксация',
            desc: 'Установка готовых керамических виниров и финальная эстетика.'
          }].map((item, idx) => <Card key={idx} className="p-6 relative overflow-hidden" data-id="element-4602" data-mp="nlpzbekcp5lo" data-mpi={idx}>
                <div className="text-6xl font-bold text-[#EFE8DE] absolute -top-4 -right-4 select-none" data-id="element-4603" data-mp="iog2veyjntoc">
                  {item.step}
                </div>
                <div className="relative z-10" data-id="element-4604" data-mp="8xldi1q04dyo">
                  <h3 className="text-xl font-bold text-[#2B2D2F] mb-3" data-id="element-4605" data-mp="8wtwbvx5iirx">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-4606" data-mp="16f2c39kabjzx">{item.desc}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. TYPES */}
      <section className="py-16 bg-white" data-id="element-4607" data-mp="2vumo6rsdo3u7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4608" data-mp="30sxz75ueske0">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-4609" data-mp="30vaflekiqmoy">
            <div data-id="element-4610" data-mp="2m3ibxzu36x32">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-4611" data-mp="2m41ikkeadz1s">
                Виды эстетической реставрации
              </h2>
              <div className="space-y-6" data-id="element-4612" data-mp="2d3mwhiti0fx8">
                <div className="flex gap-4" data-id="element-4613" data-mp="2d2txj40s6upn">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4614" data-mp="2d5zm8i5hzuku">
                    <Sparkles className="w-6 h-6" data-id="element-4615" data-mp="235fk7da5mm1k" />
                  </div>
                  <div data-id="element-4616" data-mp="237jwojm4ctdg">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4617" data-mp="284aa0z6jhav6">
                      Керамические виниры
                    </h3>
                    <p className="text-gray-600" data-id="element-4618" data-mp="1fdtzj3676be">
                      Изготавливаются в лаборатории из высокопрочной керамики.
                      Максимально эстетичные, долговечные и устойчивые к
                      изменению цвета.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4619" data-mp="1lxobl790ooaz">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4620" data-mp="20kr8pctfguxs">
                    <Palette className="w-6 h-6" data-id="element-4621" data-mp="1vtrcyaw1oiwv" />
                  </div>
                  <div data-id="element-4622" data-mp="1vsg8e8urz74p">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4623" data-mp="29l67nezbe8jr">
                      Композитный бондинг
                    </h3>
                    <p className="text-gray-600" data-id="element-4624" data-mp="24m30nozrxs95">
                      Художественная реставрация композитным материалом прямо в
                      кресле. Быстрее и доступнее, но требует периодической
                      полировки.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4625" data-mp="p64attu0yixp">
                  <div className="p-3 bg-[#F8F5F0] border border-[#D8C4A8] rounded-lg text-[#2F4A3F] h-fit" data-id="element-4626" data-mp="k7aultncsdtu">
                    <Smile className="w-6 h-6" data-id="element-4627" data-mp="37g0514xr663w" />
                  </div>
                  <div data-id="element-4628" data-mp="3cebdpccbaakj">
                    <h3 className="text-xl font-bold text-[#2B2D2F] mb-2" data-id="element-4629" data-mp="3cdih3472h1g4">
                      Smile Makeover
                    </h3>
                    <p className="text-gray-600" data-id="element-4630" data-mp="3hdwhq16c9944">
                      Комплексное преображение улыбки, которое может сочетать
                      виниры, коронки и отбеливание для идеального результата.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-4631" data-mp="2tlpnp8o35e7v">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Типы виниров" className="absolute inset-0 w-full h-full object-cover" data-id="element-4632" data-mp="2xnuc9szofknn" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS */}
      <section className="py-16 bg-[#EFE8DE]" data-id="element-4633" data-mp="22g1vrnjuxf83">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4634" data-mp="22fs6y3ajte3z">
          <div className="text-center mb-12" data-id="element-4635" data-mp="1xgz2f0d8oxfy">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-4636" data-mp="1xi0hdfxdm42y">
              Почему стоит выбрать Dentico Clinic
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-4637" data-mp="1oh2bst7ahoi9">
            {[{
            title: 'Естественный вид',
            desc: 'Мы создаем улыбки, которые выглядят натурально, а не искусственно.'
          }, {
            title: 'Минимальное вмешательство',
            desc: 'Сохраняем максимум здоровых тканей зуба благодаря современным техникам.'
          }, {
            title: 'Русский язык',
            desc: 'Легкое общение и полное понимание ваших пожеланий.'
          }, {
            title: 'Удобная локация',
            desc: 'Клиника в центре Лондона (Angel), легко добраться из любого района.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-white text-center" data-id="element-4638" data-mp="r32jg4nr4ohc" data-mpi={idx}>
                <div className="w-12 h-12 bg-[#F8F5F0] rounded-full flex items-center justify-center text-[#2F4A3F] mb-4 mx-auto border border-[#D8C4A8]" data-id="element-4639" data-mp="r19h31k68qf5">
                  <CheckCircle2 className="w-6 h-6" data-id="element-4640" data-mp="h67n9seyb068" />
                </div>
                <h3 className="text-lg font-bold text-[#2B2D2F] mb-2" data-id="element-4641" data-mp="14u7esuk36ulv">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-4642" data-mp="19ssgyziwfocy">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-16 bg-white" data-id="element-4643" data-mp="1040qywxefe4o">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4644" data-mp="102ppj3rfeigq">
          <div className="text-center mb-10" data-id="element-4645" data-mp="1ntv3fddt30oe">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-4646" data-mp="1ns1xy1eximhz">
              Частые вопросы о винирах
            </h2>
          </div>
          <Accordion items={faqs} data-id="element-4647" data-mp="3daqmt5ejzaej" />
        </div>
      </section>

      {/* 7. INTERNAL LINKS */}
      <section className="py-12 bg-gray-50 border-t border-gray-100" data-id="element-4648" data-mp="38bnijn6ed87m">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4649" data-mp="38bdrrxdj2x0v">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-4650" data-mp="3mziav2ghtak6">
            Смотрите также
          </h2>
          <div className="flex flex-wrap gap-4" data-id="element-4651" data-mp="3i2i8b1iuqpxt">
            <Link to="/ru/russkij-stomatolog-london" data-id="element-4652" data-mp="2ubuuy0q6383v">
              <Button variant="outline" size="sm" data-id="element-4653" data-mp="2ucntwfivwtbg">
                Русскоязычный стоматолог
              </Button>
            </Link>
            <Link to="/ru/services/smile-makeover" data-id="element-4654" data-mp="2pf4g1gq3mik1">
              <Button variant="outline" size="sm" data-id="element-4655" data-mp="33dlxwxtbp0u1">
                Smile Makeover
              </Button>
            </Link>
            <Link to="/ru/services/whitening" data-id="element-4656" data-mp="2z9eb566fduyg">
              <Button variant="outline" size="sm" data-id="element-4657" data-mp="im20hd4tlz0f">
                Отбеливание
              </Button>
            </Link>
            <Link to="/ru/prices" data-id="element-4658" data-mp="eli62hbmt9hz">
              <Button variant="outline" size="sm" data-id="element-4659" data-mp="ekgsa538e8wk">
                Цены
              </Button>
            </Link>
            <Link to="/ru/contact" data-id="element-4660" data-mp="281crnm6q71vv">
              <Button variant="outline" size="sm" data-id="element-4661" data-mp="2d20q2sxaal04">
                Контакты
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 8. CTA */}
      <section className="py-16 bg-forest-900" data-id="element-4662" data-mp="2ms3fyk93ziu8">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-4663" data-mp="2mtwok53a8d4v">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-4664" data-mp="2qugkj5c4dapf">
            Мечтаете об идеальной улыбке?
          </h2>
          <p className="text-xl text-ivory/80 mb-8 max-w-2xl mx-auto" data-id="element-4665" data-mp="2vrqhr75r2qnt">
            Запишитесь на консультацию и узнайте, как виниры могут изменить вашу
            жизнь.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-4666" data-mp="35q6atfoc89zy">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4667" data-mp="16e3lhot18led">
              <Button variant="primary" surface="dark" size="lg" className="w-full gap-2" data-id="element-4668" data-mp="1bfashlncpgjz">
                <Calendar className="w-5 h-5" data-id="element-4669" data-mp="3jvy8vtid3a1x" />
                Записаться онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-4670" data-mp="3fve9ejabfucm">
              <Button variant="whatsapp" surface="dark" size="lg" className="w-full gap-2" data-id="element-4671" data-mp="bfmygooubwg4">
                <MessageCircle className="w-5 h-5" data-id="element-4672" data-mp="2fqc4tpxb9o8" />
                WhatsApp
              </Button>
            </a>
            <Button variant="secondary" surface="dark" size="lg" className="w-full sm:w-auto gap-2" onClick={() => setIsCallbackOpen(true)} data-id="element-4673" data-mp="3tlhrcy25x1w9">
              <Phone className="w-5 h-5" data-id="element-4674" data-mp="2i5t6cc8gycy3" />
              Заказать звонок
            </Button>
            <a href="tel:+447345197820" className="w-full sm:w-auto" data-id="element-4675" data-mp="2tw2eq8bnrrua">
              <Button variant="secondary" surface="dark" size="lg" className="w-full gap-2" data-id="element-4676" data-mp="2p3iz75teummu">
                <Phone className="w-5 h-5" data-id="element-4677" data-mp="2f5mp8hc7lxqb" />
                Позвонить
              </Button>
            </a>
            <Link to="/ru/prices#crowns-veneers" className="w-full sm:w-auto" data-id="element-4678" data-mp="3ct3oe6g5qg4k">
              <Button variant="secondary" surface="dark" size="lg" className="w-full" data-id="element-4679" data-mp="3cr0uvcfsq4v3">
                Цены
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}